import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: "app-time-state-selector",
  templateUrl: "./time-state-selector.component.html",
  styleUrls: ["./time-state-selector.component.scss"],
})
export class TimeStateSelectorComponent implements OnInit {
  @Input() time_state!: number;
  @Output() time_stateUpdate: EventEmitter<number> = new EventEmitter();

  constructor(public appSettings: SettingsService) {}

  ngOnInit() {}

  emitTime() {
    this.time_stateUpdate.emit(this.time_state);
  }
}
